// ناوبری به صفحه جزئیات (جزئیات خدمت، جزئیات کارکن) از فهرست‌ها و دیالوگ‌ها. پیش‌فرض Router است؛ صفحه میزبان (پنل مرحله Setup Wizard
// — SCR-STAFF-900، AP-PLT-04) می‌تواند مسیر را درون خود باز کند تا کاربر از Wizard بیرون نرود و همان صفحات بدون کپی استفاده شوند.
import { createContext, useCallback, useContext, type MouseEvent, type ReactNode } from 'react';
import { useNavigate } from 'react-router';

/** باز کردن مسیر جزئیات درون میزبان؛ <c>true</c> یعنی میزبان آن را باز کرد. */
export type DetailOpener = (path: string) => boolean;

const DetailNavigationContext = createContext<DetailOpener | null>(null);

export function DetailNavigationProvider({ open, children }: { open: DetailOpener; children: ReactNode }) {
  return <DetailNavigationContext.Provider value={open}>{children}</DetailNavigationContext.Provider>;
}

/** رفتن به مسیر جزئیات (درون میزبان در صورت وجود، وگرنه Router). */
export function useDetailNavigate(): (path: string) => void {
  const navigate = useNavigate();
  const open = useContext(DetailNavigationContext);
  return useCallback(
    (path: string) => {
      if (!open?.(path)) {
        void navigate(path);
      }
    },
    [navigate, open],
  );
}

/** onClick لینک جزئیات: درون میزبان باز می‌شود و ناوبری Router لغو می‌شود. */
export function useDetailLinkClick(): (path: string) => (event: MouseEvent) => void {
  const open = useContext(DetailNavigationContext);
  return useCallback(
    (path: string) => (event: MouseEvent) => {
      event.stopPropagation();
      if (open?.(path)) {
        event.preventDefault();
      }
    },
    [open],
  );
}
